import React from "react";
import Navbar from "../components/Navbar";
import Carousel from "../components/Carousel";
import AboutUs from "../components/AboutUs";
import Product from "../components/Product";
import Features from "../components/Features";
import QualityPromise from "../components/QualityPromise";
import Contact from "../components/Contact";

const Home = () => (
  <>
    <Navbar />
    <Carousel />
    <AboutUs />
    <section id="products">
      <Product />
    </section>
    <section id="features">
      <Features />
    </section>
    <section id="quality-promise">
      <QualityPromise />
    </section>

    <section id="contact">
      <Contact />
    </section>
  </>
);

export default Home;
